import React, {Component} from "react";
import cmsRequest from "../../api/cmsRequest";
import Footer from "../../components/Footer"

class Crest extends Component {

    constructor(props) {
        super(props);
        this.state = {
            mainImgItem: {},
            year: 2024,
            ICPCodeItem: {},
            recordCodeItem: {}
        };
    }

    componentDidMount() {
        document.title = '佳洁士官网'
        cmsRequest.request({ mid: 'edc6446139' })
            .then(result => {
                let cmsData = result.data
                let mainImgItem = cmsData.find(item => item.id === 'b87981e8eb').content[0]
                let ICPCodeItem = cmsData.find(item => item.id === 'c1fabff15e')
                let recordCodeItem = cmsData.find(item => item.id === 'a00d8eab59')
                this.setState({
                    mainImgItem,
                    ICPCodeItem,
                    recordCodeItem
                })
            })
            .catch(err => {
                console.log('data catch', err)
            })
        
        cmsRequest.request({ mid: '494d6de189' })
            .then(result => {
                let cmsData = result.data
                let year = cmsData.find(item => item.id === '63a92cfade').content
                this.setState({
                    year
                })
            })
            .catch(err => {
                console.log('year catch', err)
            })
    }

    render() {
        let { mainImgItem, year, ICPCodeItem, recordCodeItem } = this.state
        return (
            <div className="homePage">
                {
                    mainImgItem.isShow && (
                        <img className="mainImg" src={mainImgItem.imageUrl} alt={mainImgItem.parameters[0].value}></img>
                    )
                }
                {
                    ICPCodeItem.isShow && recordCodeItem.isShow && (
                        <Footer ICPCodeItem={ICPCodeItem} recordCodeItem={recordCodeItem} year={year}></Footer>
                    )
                }
            </div>
        )
    }
}

export default Crest;